"use client";
import { buildProvider } from "@jb-dotcom/config";
import type { Config } from "@jb-dotcom/config/dotcom";

const { ClientConfigProvider, useConfig } = buildProvider<Config>();

export { ClientConfigProvider, useConfig };
